const texmexData = [
    {
        title: "Camembert pané",
        image: require("../image/texmex/texmex-camembert.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "texmexprice",
        top: "",
    },
    {
        title: "Jalapenos",
        image: require("../image/texmex/texmex-jalapenos.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "texmexprice",
        top: "*",
    },
    {
        title: "Mozza sticks",
        image: require("../image/texmex/texmex-mozzastick.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "texmexprice",
        top: "",
    },
    {
        title: "Nuggets",
        image: require("../image/texmex/texmex-nuggets.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "texmexprice",
        top: "*",
    },
    {
        title: "Onion rings",
        image: require("../image/texmex/texmex-onionrings.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "texmexprice",
        top: "",
    },
    {
        title: "Tenders",
        image: require("../image/texmex/texmex-tenders.png"),
        paragraphe: "Accompagné de sauce barbecue",
        price: "tendersprice",
        top: "",
    },
];

export default texmexData;
